// @mui material components
import { CircularProgress, Backdrop, Snackbar, Alert, Card, Grid, Icon } from "@mui/material";

import { useState } from "react";
// import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
// import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";

import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";
import { PopupModal } from "react-calendly";
import AppConfig from "appConfig";

function HomeDashboard() {
  const pageTitle = "Laddar Portal - Home";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const auth = useAuthUser();
  const user = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setSeverity("error");
    setShowLoading(false);
  };

  const [openCalendly, setOpenCalendly] = useState(false);

  function greet() {
    const myDate = new Date();
    const hours = myDate.getHours();
    let greetingMsg;

    if (hours < 12) greetingMsg = "morning";
    else if (hours >= 12 && hours <= 15) greetingMsg = "afternoon";
    else if (hours >= 16 && hours <= 24) greetingMsg = "evening";

    return `Good ${greetingMsg}`;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <PopupModal
        url={AppConfig.calendly_link}
        onModalClose={() => setOpenCalendly(false)}
        open={openCalendly}
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        rootElement={document.getElementById("root")}
      />
      <MDBox mb={5}>
        <MDBox mt={1}>
          <MDBox mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8} lg={8}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={2}>
                    <MDBox align="center">
                      <MDTypography variant="h6" fontWeight="light">
                        {greet()} <b>{user.user.first_name}</b>
                      </MDTypography>
                    </MDBox>
                    <MDBox
                      mt={2}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <MDBox align="center">
                        <MDBox>
                          <MDTypography variant="h2">{user.account.title}</MDTypography>
                        </MDBox>
                        <MDBox m={2}>
                          <Icon>label</Icon>
                          <MDTypography variant="h6" fontSize={12} fontWeight="light">
                            {user.account.plan.title}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox m={1} p={2} align="center" bgColor="dark" sx={{ height: "100%" }}>
                    <MDBox>
                      <MDTypography fontSize={36} color="white">
                        <Icon color="white">today</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={16} fontWeight={100} color="white">
                        Need help getting started?
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="warning"
                        startIcon={<Icon>calendar_month</Icon>}
                        onClick={() => {
                          setOpenCalendly(true);
                        }}
                      >
                        Book A Demo
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/agents");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">support_agent</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Teams
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Manage your teams effectively. Monitor activities, track performance and
                        reward seamlessly.
                        <br />
                        <br />
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/agents");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/campaigns");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">workspaces</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Field Operations
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Power your field operations end-to-end.
                        <br />
                        From sales, data collections, audits, user onboardings, asset tracking,
                        activity reporting and much more.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/campaigns");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              {/* <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/trade-marketing/");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">ads_click</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Trade Marketing
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Run multiple marketing promotions seamlessly. Monitor, track and measure
                        results. Get realtime reports, insights, retail performance and
                        distribution.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/trade-marketing");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid> */}
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/voice/numbers");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">dialer_sip</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Voice
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Transform your business calls with LaddarVoice
                        <br />
                        <b>Get a business number</b> | <b>Manage multiple virtual call centers.</b>
                        <br />
                        Monitor calls, track team performance and access AI powered call analytics.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/voice/numbers");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/leads/profiles");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">attribution</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Lead Management
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Create and manage multiple lead profiles. Setup lead buckets and organise
                        lead your journey into pipelines.
                        <br />
                        <br />
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/leads/profiles");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/agent-benefits");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">money</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Benefits
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Manage team benefits such as salaries, allowances and much more. Empower
                        your team with cash, airtime or data.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/agent-benefits");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/trainings");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">school</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Train
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Train your teams. Create byte-sized courses and set assessments to evaluate
                        and ensure high delivery across board.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/trainings");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                <Card sx={{ height: "100%" }}>
                  <MDBox
                    p={2}
                    align="center"
                    onClick={() => {
                      navigate("/messaging/groups");
                    }}
                  >
                    <MDBox>
                      <MDTypography variant="h6" fontSize={18}>
                        <Icon color="dark">message</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={18}>
                        Messaging
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={14} fontWeight="light">
                        Maintain realtime communication with your customers, agents or prospects.
                        Send messages across multiple messaging channels with ease.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          onClick={() => {
                            navigate("/messaging/groups");
                          }}
                          iconOnly
                        >
                          <Icon>east</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default HomeDashboard;
